var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6492 11.4629C28.8146 11.4629 31.3806 8.89684 31.3806 5.73145C31.3806 2.56606 28.8146 0 25.6492 0C22.4838 0 19.9177 2.56606 19.9177 5.73145C19.9177 8.89684 22.4838 11.4629 25.6492 11.4629Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6487 49.002C27.5477 49.002 29.0872 47.4625 29.0872 45.5635C29.0872 43.6645 27.5477 42.125 25.6487 42.125C23.7497 42.125 22.2102 43.6645 22.2102 45.5635C22.2102 47.4625 23.7497 49.002 25.6487 49.002Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5654 16.7217C14.4145 16.7217 16.7241 14.412 16.7241 11.563C16.7241 8.71392 14.4145 6.4043 11.5654 6.4043C8.71636 6.4043 6.40674 8.71392 6.40674 11.563C6.40674 14.412 8.71636 16.7217 11.5654 16.7217Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7317 42.5928C41.3144 42.5928 42.5974 41.3097 42.5974 39.7271C42.5974 38.1444 41.3144 36.8613 39.7317 36.8613C38.149 36.8613 36.866 38.1444 36.866 39.7271C36.866 41.3097 38.149 42.5928 39.7317 42.5928Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73163 30.2325C8.26333 30.2325 10.3157 28.1802 10.3157 25.6485C10.3157 23.1168 8.26333 21.0645 5.73163 21.0645C3.19993 21.0645 1.14758 23.1168 1.14758 25.6485C1.14758 28.1802 3.19993 30.2325 5.73163 30.2325Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5638 27.9377C46.8291 27.9377 47.8549 26.9119 47.8549 25.6466C47.8549 24.3812 46.8291 23.3555 45.5638 23.3555C44.2985 23.3555 43.2727 24.3812 43.2727 25.6466C43.2727 26.9119 44.2985 27.9377 45.5638 27.9377Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72984 36.8956C7.16216 38.4633 7.16216 40.9999 8.72984 42.5676C10.2957 44.1353 12.836 44.1353 14.4018 42.5676C15.9695 40.9999 15.9695 38.4633 14.4018 36.8956C12.836 35.3261 10.2975 35.3112 8.72984 36.8956Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7292 13.2823C40.6782 13.2823 41.4475 12.513 41.4475 11.564C41.4475 10.615 40.6782 9.8457 39.7292 9.8457C38.7802 9.8457 38.0109 10.615 38.0109 11.564C38.0109 12.513 38.7802 13.2823 39.7292 13.2823Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49.0019,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.6ecf7396.svg";
export { ForwardRef as ReactComponent };